import { QueryHookOptions } from '@apollo/client';

import {
  useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery,
  RetailerNetworkTobaccoManufacturerOfferPerformanceQuery,
  RetailerNetworkTobaccoManufacturerOfferPerformanceFragment,
  RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables,
  RetailerNetworkTobaccoManufacturerOfferPerformanceFilter,
} from '@occc/graphql';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';

const PAGE_SIZE = 50;

type UseRetailerNetworkTobaccoManufacturerOfferPerformanceProps = {
  baseOptions?: QueryHookOptions<
    RetailerNetworkTobaccoManufacturerOfferPerformanceQuery,
    RetailerNetworkTobaccoManufacturerOfferPerformanceQueryVariables
  >;
  paginationInfo?: PaginationInfo;
  filter: RetailerNetworkTobaccoManufacturerOfferPerformanceFilter;
};

const transformToManufacturerOfferPerformanceArray = (
  data: RetailerNetworkTobaccoManufacturerOfferPerformanceQuery,
): RetailerNetworkTobaccoManufacturerOfferPerformanceFragment[] => {
  const { edges } = data.retailerNetworkTobaccoManufacturerOfferPerformance;
  return edges?.map((item) => item.node) || [];
};

export const useRetailerNetworkTobaccoManufacturerOfferPerformance = ({
  filter,
  baseOptions,
  paginationInfo,
}: UseRetailerNetworkTobaccoManufacturerOfferPerformanceProps) => {
  const response = usePaginatedQuery(
    useRetailerNetworkTobaccoManufacturerOfferPerformanceQuery,
    'retailerNetworkTobaccoManufacturerOfferPerformance.pageInfo',
    PAGE_SIZE,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
  );

  return {
    ...response,
    data: response.data
      ? transformToManufacturerOfferPerformanceArray(response.data)
      : response.data,
  };
};
